module.exports = __webpack_public_path__ + "static/logo-white-cb84b263045f452a9fe80c4c08fb746c.svg";